<template lang="pug">
.calendar-month-view
  table
    thead
      tr
        th.smaller(colspan="7") {{monthNames[this.month-1]}} {{this.year}}
      tr
        th Mo
        th Di
        th Mi
        th Do
        th Fr
        th Sa
        th So
    tbody
      tr(v-for="w in weeks")
        td(v-for="d in 7"
          :class="{selected: checkIfBlocked(d, w) === 'select', invalid: dayNumber(d, w) <= 0 || dayNumber(d, w) > daysInMonth, free: ['free', 'start_blocked', 'end_blocked', 'start_select', 'end_select'].includes(checkIfBlocked(d, w)), blocked: checkIfBlocked(d, w) === 'blocked', hover: mode === 'hover'}"
          @click="$emit('selectedDate', selectedDate(d,w))" @mouseenter="$emit('hoverDate', selectedDate(d,w))")
          .start.select-icon(v-if="['start_select', 'end_blocked_start_select'].includes(checkIfBlocked(d, w))")
          .end.select-icon(v-if="['end_select', 'end_select_start_blocked'].includes(checkIfBlocked(d, w))")
          .start(v-if="['start_blocked', 'start_end_blocked', 'end_select_start_blocked'].includes(checkIfBlocked(d, w))")
          .end(v-if="['end_blocked', 'start_end_blocked', 'end_blocked_start_select'].includes(checkIfBlocked(d, w))")
          .nr {{dayNumber(d, w)}}
</template>

<script>
import { DateTime } from 'luxon'
export default {
  props: {
    mode: {
      type: String,
      default: 'start'
    },
    month: {
      type: Number,
      default: DateTime.local().month
    },
    year: {
      type: Number,
      default: DateTime.local().year
    },
    selected: {
      type: Object,
      default () {
        return {
          startDate: null,
          endDate: null
        }
      }
    },
    bookings: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      monthNames: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
      ]
    }
  },
  computed: {
    daysInMonth () {
      const d = DateTime.local(this.year, this.month, 1)
      return d.daysInMonth
    },
    startWeekday () {
      const d = DateTime.local(this.year, this.month, 1)
      return d.weekday
    },
    weeks () {
      return Math.ceil((this.daysInMonth + this.startWeekday - 1) / 7)
    }
  },
  methods: {
    dayNumber (d, w) {
      return d + (w - 1) * 7 - this.startWeekday + 1
    },
    checkIfBlocked (d, w) {
      const currentDate = DateTime.local(
        this.year,
        this.month,
        this.dayNumber(d, w)
      )

      // if (currentDate <= DateTime.local()) { return false }

      const state = {
        start_blocked: false,
        end_blocked: false,
        blocked: false,
        start_select: false,
        end_select: false,
        select: false
      }

      // Here we check for selected
      if (
        this.selected.startDate &&
        this.selected.startDate.day === currentDate.day &&
        this.selected.startDate.month === currentDate.month &&
        this.selected.startDate.year === currentDate.year
      ) {
        state.start_select = true
      }

      if (
        this.selected.endDate &&
        this.selected.endDate.day === currentDate.day &&
        this.selected.endDate.month === currentDate.month &&
        this.selected.endDate.year === currentDate.year
      ) {
        state.end_select = true
      }

      if (this.selected.startDate != null && this.selected.endDate != null) {
        if (
          this.selected.startDate <= currentDate &&
          currentDate <= this.selected.endDate
        ) { state.select = true }
      } else if (this.selected.endDate != null) {
        if (currentDate <= this.selected.endDate) { state.select = true }
      } else if (this.selected.startDate != null) {
        if (this.selected.startDate.equals(currentDate)) { state.select = true }
      }

      // Here we check for blocked
      for (let i = 0; i < this.bookings.length; i += 1) {
        const startDate = DateTime.fromISO(this.bookings[i].startDate)
        const endDate = DateTime.fromISO(this.bookings[i].endDate)

        if (
          startDate.day === currentDate.day &&
          startDate.month === currentDate.month &&
          startDate.year === currentDate.year
        ) {
          state.start_blocked = true
        }

        if (
          endDate.day === currentDate.day &&
          endDate.month === currentDate.month &&
          endDate.year === currentDate.year
        ) {
          state.end_blocked = true
        }

        if (startDate <= currentDate && currentDate <= endDate) {
          state.blocked = true
        }
      }

      if (state.start_blocked && state.end_blocked) {
        return 'start_end_blocked'
      }
      if (state.start_select && state.end_blocked) {
        return 'end_blocked_start_select'
      }
      if (state.start_blocked && state.end_select) {
        return 'end_select_start_blocked'
      }
      if (state.start_select) {
        return 'start_select'
      }
      if (state.end_select) {
        return 'end_select'
      }
      if (state.select) {
        return 'select'
      }
      if (state.start_blocked) {
        return 'start_blocked'
      }
      if (state.end_blocked) {
        return 'end_blocked'
      }
      if (state.blocked) {
        return 'blocked'
      }
      return 'free'
    },
    selectedDate (d, w) {
      if (this.selected.startDate === null && this.selected.endDate === null) {
        this.startDayNumber = this.dayNumber(d, w)
      } else {
        this.endDayNumber = this.dayNumber(d, w)
      }
      return DateTime.local(this.year, this.month, this.dayNumber(d, w))
    }
  }
}
</script>

<style lang="scss" scoped>
.calendar-month-view {
  table {
    width: 100%;
    table-layout: fixed;
    text-align: center;
    vertical-align: baseline;
    border-collapse: collapse;
    border: solid 1px $lightgray;
    user-select: none;
    thead {
      tr {
        border: solid 1px $lightgray;
        th {
          font-weight: 500;
          border: solid 1px $lightgray;
          height: 40px;
          background-color: white;
          &.smaller {
            height: 24px;
            font-size: 0.9rem;
          }
        }
      }
    }
    tbody {
      tr {
        border: solid 1px $lightgray;
        td {
          position: relative;
          border: solid 1px $lightgray;
          height: 40px;
          .nr {
            position: absolute;
            z-index: 2;
            // background-color: rgba(white, 0.32);
            border-radius: 100%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            height: 24px;
            width: 24px;
            // color: black;
            text-align: center;
            line-height: 24px;
          }
          .start {
            position: absolute;
            height: 100%;
            width: 50%;
            top: 0;
            right: 0;
            border-top-left-radius: 99px;
            border-bottom-left-radius: 99px;
            background-color: $lightgray;
            &.select-icon {
              background-color: rgba($secondary, 1);
            }
          }
          .end {
            position: absolute;
            height: 100%;
            width: 50%;
            top: 0;
            left: 0;
            border-top-right-radius: 99px;
            border-bottom-right-radius: 99px;
            background-color: $lightgray;
            &.select-icon {
              background-color: rgba($secondary, 1);
            }
          }
          img {
            position: absolute;
            top: -1px;
            height: calc(100% + 1px);
            width: calc(50% + 2px);
            &.start {
              right: -2.5px;
            }
            &.end {
              left: -2.5px;
            }
          }
          &.free {
            color: $black;
            // background-color: rgb(191, 247, 198);
          }
          &.selected {
            color: $black;
            background-color: rgba($secondary, 1);
            &.hover {
              background-color: rgba($secondary, 0.32);
            }
          }
          &.blocked {
            color: $black;
            pointer-events: none;
            background-color: $lightgray;
          }
          &.past {
            pointer-events: none;
            color: $gray;
            text-decoration: line-through;
            background-color: $lightgray;
          }
          &.invalid {
            pointer-events: none;
            color: transparent;
            background-color: $light;
          }
        }
      }
    }
  }
}
</style>
